import script from "./StarsRating.vue?vue&type=script&lang=js"
export * from "./StarsRating.vue?vue&type=script&lang=js"

export default script